import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function CommonHeader({ logoutClick, classes }) {
  const { localization } = useLanguageContext();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("organization");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("userId");
    logoutClick();
  };

  return (
    <div className="col-2 d-flex justify-content-end">
      <IconButton
        className={classes.accountIconButton}
        //style={{ padding: "0px" }}
        onClick={handleClick}
        aria-controls="user-menu"
        aria-haspopup="true"
      >
        <AccountCircleIcon className={classes.accountIcon} />
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Typography variant="h5" className={classes.headerStyle}>
          {sessionStorage.getItem("username")}
        </Typography>
        <Typography variant="h6" className={classes.headerStyle}>
          {sessionStorage.getItem("organization")}
        </Typography>
        <Typography
          className={classes.headerStyle}
          variant="h6"
          onClick={handleLogout}
        >
          {localization.Logout}
        </Typography>
      </Menu>
    </div>
  );
}
